import { type ContextType } from 'hypernova/server';
import { QueryClient } from '@tanstack/react-query';

export function createQueryClient({ metadata: { translations } }: ContextType) {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: parseInt(process.env.API_STALE_TIME, 10)
      }
    }
  });
  client.setQueryData(['static', 'prefetch', 'captions'], translations);

  return client;
}
